import React, { useState, useRef} from 'react'

function Shortner({setInputValue}) {

  const [value, setValue] = useState("")
  const formInputValue = useRef(null)

const handleClick = () => {
  setInputValue(value);
  formInputValue.current.value = ""
  setValue("");
}


  return (
    <div className='inputContainer bg-darkVoilet px-2 sm:px-16 py-8 flex flex-col justify-center items-center'>
       <div className='flex flex-col sm:flex-row mb-2 sm:mb-8 items-center'>
         <input type="text" ref={formInputValue} value={value} 
         onChange={(e) => setValue(e.target.value)}
         placeholder='shorten a link here' required className='w-full sm:w-[1154px] p-2 indent-1 outline-red-900 rounded-md'></input>
         <button className='p-2 bg-cyan text-white sm:mx-2 w-full sm:w-44 rounded-lg uppercase my-4 sm:my-0'
         onClick={handleClick}
         >Shorten it!</button>
    </div>
    </div>
  )
}

export default Shortner